import { Injectable } from '@angular/core';
import { TreeviewItem, TreeviewSelection, TreeviewI18n } from 'ngx-treeview';
import { I18n } from './i18n';

@Injectable()
export class DefaultTreeviewI18n extends TreeviewI18n {
  constructor(
    protected i18n: I18n
  ) {
    super();
  }

  getText(selection: TreeviewSelection): string {
    if (selection.uncheckedItems.length === 0) {
      if (selection.checkedItems.length > 0) {
        return this.i18n.language === 'en' ? 'All' : 'Todos';
      } else {
        return '';
      }
    }

    switch (selection.checkedItems.length) {
      case 0:
        return this.i18n.language === 'en' ? 'Select options' : 'Seleccione opciones';
      case 1:
        return selection.checkedItems[0].text;
      default:
        return this.i18n.language === 'en'
          ? `${selection.checkedItems.length} options selected`
          : `${selection.checkedItems.length} opciones seleccionadas`;
    }
  }

  getAllCheckboxText(): string {
    if (this.i18n.language === 'en') {
      return 'All';
    } else {
      return 'Todos';
    }
  }

  getFilterPlaceholder(): string {
    if (this.i18n.language === 'en') {
      return 'Find';
    } else {
      return 'Buscar';
    }
  }

  getFilterNoItemsFoundText(): string {
    if (this.i18n.language === 'en') {
      return 'No students found';
    } else {
      return 'No se encontraron estudiantes';
    }
  }

  getTooltipCollapseExpandText(isCollapse: boolean): string {
    return isCollapse
      ? this.i18n.language === 'en' ? 'Expand' : 'Expandir'
      : this.i18n.language === 'en' ? 'Collapse' : 'Colapsar';
  }
}